// extracted by mini-css-extract-plugin
export default {"container":"BloggerStudyAi_container__62Bu5","title":"BloggerStudyAi_title__idIJa","textarea":"BloggerStudyAi_textarea__1PFvf"};